import React, { useState } from 'react';
import { Header } from './components/Header';
import { HamburgerOverlay } from './components/HamburgerOverlay';
import { HeroSection } from './components/HeroSection';
import { TerroirSection } from './components/TerroirSection';
import { FeaturedWinesSection } from './components/FeaturedWinesSection';
import { BotanicalStorySection } from './components/BotanicalStorySection';
import { CraftSection } from './components/CraftSection';
import { SustainabilitySection } from './components/SustainabilitySection';
import { PressQuoteSection } from './components/PressQuoteSection';
import { FinalStatementSection } from './components/FinalStatementSection';
import { Footer } from './components/Footer';
export function App() {
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  return <div className="min-h-screen bg-charcoal text-white font-serif selection:bg-gold selection:text-charcoal" data-id="element-0">
      <Header onOpenMenu={() => setIsMenuOpen(true)} data-id="element-1" />

      <HamburgerOverlay isOpen={isMenuOpen} onClose={() => setIsMenuOpen(false)} data-id="element-2" />

      <main data-id="element-3">
        <HeroSection data-id="element-4" />
        <TerroirSection data-id="element-5" />
        <FeaturedWinesSection data-id="element-6" />
        <BotanicalStorySection data-id="element-7" />
        <CraftSection data-id="element-8" />
        <SustainabilitySection data-id="element-9" />
        <PressQuoteSection data-id="element-10" />
        <FinalStatementSection data-id="element-11" />
      </main>

      <Footer data-id="element-12" />
    </div>;
}